(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.querySelector('.announcement-bar');
  const slides = announcementBar.querySelectorAll('.announcement-bar__slide');
  const prevButton = announcementBar.querySelector('.announcement-bar__prev');
  const nextButton = announcementBar.querySelector('.announcement-bar__next');
  const dismissButton = announcementBar.querySelector('.announcement-bar__dismiss');
  const header = document.querySelector('.site-header');
  let currentIndex = 0;
  let slideInterval;

  // Lire les data attributes
  const autoRotate = announcementBar.getAttribute('autoRotate') === 'true';
  const changeSpeed = parseInt(announcementBar.getAttribute('changeSpeed'), 10) * 1000 || 5000;

  // Initial setup
  function initSlides() {
    slides.forEach((slide, index) => {
      if (index === 0) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
  }

  initSlides();

  // Fonction pour afficher la diapositive suivante
  function showNextSlide() {
    slides[currentIndex].classList.remove('active');
    currentIndex = (currentIndex + 1) % slides.length;
    slides[currentIndex].classList.add('active');
  }

  // Fonction pour afficher la diapositive précédente
  function showPrevSlide() {
    slides[currentIndex].classList.remove('active');
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    slides[currentIndex].classList.add('active');
  }

  // Gestion des clics sur les boutons
  if (nextButton) {
    nextButton.addEventListener('click', function() {
      showNextSlide();
      resetAutoRotate();
    });
  }

  if (prevButton) {
    prevButton.addEventListener('click', function() {
      showPrevSlide();
      resetAutoRotate();
    });
  }

  // Gestion du bouton de suppression
  if (getCookie('header-dismiss') === 'true') {
    // If cookie is set, hide the announcement bar and remove padding
    if (announcementBar) announcementBar.style.display = 'none';
    document.body.style.paddingTop = '0';
  } else {
    // If no cookie, show the announcement bar and add event listener to dismiss
    if (dismissButton) {
      dismissButton.addEventListener('click', function() {
        // Set cookie for 30 days
        setCookie('header-dismiss', 'true', 30);
        if (announcementBar) announcementBar.style.display = 'none';
        document.body.style.paddingTop = '0';
      });
    }
  }

  // Function to set a cookie with a given name, value, and expiration in days
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  // Function to get a cookie by name
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  // Rotation automatique des diapositives
  function startAutoRotate() {
    if (autoRotate) {
      slideInterval = setInterval(showNextSlide, changeSpeed);
    }
  }

  function resetAutoRotate() {
    if (autoRotate) {
      clearInterval(slideInterval);
      startAutoRotate();
    }
  }

  startAutoRotate();

  // Remplacement de la barre d'annonce par le header lors du défilement
  window.addEventListener('scroll', function() {
    if (window.scrollY > announcementBar.offsetHeight) {
      header.classList.add('visible');
      announcementBar.style.top = `-${announcementBar.offsetHeight}px`;
    } else {
      header.classList.remove('visible');
      announcementBar.style.top = '0';
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
